/** @format */
import { css } from 'styled-components';

import { quietTextHighlight, quietTextSmall } from '../../../typography';

export const styles = css`
    --kit-model-row__thumbnail-size: 4.8rem;

    display: flex;
    align-items: center;
    gap: var(--layout-spacing-12);
    list-style: none;

    .kit-model-row-thumbnail {
        flex: 0 0 auto;
        background-color: var(--colors-surface-secondary);
        border-radius: var(--effects-radius-sm);
        overflow: hidden;
    }

    .kit-model-row-thumbnail img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .kit-model-row-details {
        display: flex;
        flex-direction: column;
        min-width: 0;
        flex: 1 1 auto;
    }

    .kit-model-row-name {
        ${quietTextHighlight}
        color: var(--colors-text-secondary);
        overflow-wrap: anywhere;

        &:hover {
            color: var(--colors-interactive-primary-hover);
            text-decoration: underline;
        }
    }

    .kit-model-row-tag {
        ${quietTextSmall}
        color: var(--colors-text-tertiary);
        text-transform: uppercase;
    }

    .kit-model-row-share {
        ${quietTextHighlight}
        flex: 0 0 auto;
        color: var(--colors-brand-secondary);
        text-align: right;
    }
`;
